(function () {

    'use strict';

    angular.module('iplusjs.filter.stringReplace', [
        'lodash'
    ])
    .filter('stringReplace', StringReplace);

    StringReplace.$inject = [
        'lodash'
    ];
    function StringReplace(_) {
        return function (str, pattern, replacement, flags) {
            flags = flags || '';
            str = _.isString(str) ? str : str + '';
            return str.replace(new RegExp(pattern, flags), replacement || '');
        };
    }
})();
